import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultAtpConfig, getTemplateConfig } from './cfg.default';

const cfg = {
  policySubType: 0,
  policyType: 3,
  tmVirusscans: {
    vsFileTagContent: '[MaliciousContent]',
    vsWormsTrojansActionType: 109,
    vsReplacementText:
      'This file is %Action% because it triggered %FilterName%.\nContact your Cloud App Security administrator for further support or information.',
  },

  tmFileblockings: {
    fbActionType: 109,
    fbFileTagContent: '[FileBlocked]',
  },

  tmWebthreatprotections: {
    wtpExtractAttachmentUrl: 1,
    wtpApprovedHeaderList: '',
    wtpFileTagContent: '[RiskyURLInside]',
  },

  tmDdafilters: {},
};

export function getOneDriveTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined
) {
  const coverI18nKeys = [
    'policy.policyTemplate.SPOD.tmVirusscans.vsReplacementText',
    'policy.policyTemplate.SPOD.tmDdafilters.ddaReplacementText',
    'policy.policyTemplate.SPOD.tmFileblockings.fbReplacementFileName',
    'policy.policyTemplate.SPOD.tmFileblockings.fbReplacementText',
    'policy.policyTemplate.SPOD.tmWebthreatprotections.wtpReplacementText',
    'policy.policyTemplate.SPOD.tmVirusscans.vsFileTagContent',
    'policy.policyTemplate.SPOD.tmFileblockings.fbFileTagContent',
    'policy.policyTemplate.SPOD.tmWebthreatprotections.wtpFileTagContent',
  ];
  const ntfI18nReplaceKeys = [
    'policy.policyTemplate.OD.tmFileblockings.notification.ntfAdminMessage',
    'policy.policyTemplate.OD.tmFileblockings.notification.ntfAdminSubject',
    'policy.policyTemplate.OD.tmFileblockings.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.OD.tmFileblockings.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.OD.tmVirusscans.notification.ntfAdminMessage',
    'policy.policyTemplate.OD.tmVirusscans.notification.ntfAdminSubject',
    'policy.policyTemplate.OD.tmVirusscans.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.OD.tmVirusscans.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.OD.tmWebthreatprotections.notification.ntfAdminMessage',
    'policy.policyTemplate.OD.tmWebthreatprotections.notification.ntfAdminSubject',
    'policy.policyTemplate.OD.tmWebthreatprotections.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.OD.tmWebthreatprotections.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.OD.tmDdafilters.notification.ntfAdminMessage',
    'policy.policyTemplate.OD.tmDdafilters.notification.ntfAdminSubject',
    'policy.policyTemplate.OD.tmDdafilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.OD.tmDdafilters.notification.ntfInternalRecipientSubject',
  ];
  const tempConfig = getDefaultAtpConfig();
  merge(tempConfig, cfg);
  return getTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    coverI18nKeys,
    ntfI18nReplaceKeys
  );
}
